const selectGroupKey = /* @__PURE__ */ Symbol("ElSelectGroup");
const selectKey = /* @__PURE__ */ Symbol("ElSelect");

export { selectGroupKey, selectKey };
//# sourceMappingURL=token.mjs.map
